import { RHFAutoCompleteVirtualize } from '@openx/components-core/lib/AutoComplete/RHFAutoCompleteVirtualize.tsx';
import type { ChangeEvent, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { DealParticipantsField } from '../fields.ts';

import type { ParticipantBuyersMultipleProps } from './ParticipantBuyersMultiple.tsx';

export interface ParticipantBuyerTTDProps {
  mainBuyerOptions: string[];
  isTTDPartnerAndGuaranteedDealType: boolean;
  mainBuyer?: string | null;
  isBuyersLoading: boolean;
  onMainBuyerChange: (e: ChangeEvent<HTMLInputElement>, v: string) => void;
  onMultipleBuyerIdsChange: (e: ChangeEvent<HTMLInputElement>, v: string[]) => void;
}

export const ParticipantBuyersTTD = ({
  fieldPrefix,
  getBuyerOptionLabel,
  mainBuyerOptions,
  onMainBuyerChange,
  isBuyersLoading,
  isTTDPartnerAndGuaranteedDealType,
  mainBuyer,
  filteredBuyersOption,
  onMultipleBuyerIdsChange,
}: ParticipantBuyersMultipleProps & ParticipantBuyerTTDProps) => {
  const { t } = useTranslation();

  return (
    <>
      <RHFAutoCompleteVirtualize
        name={`${fieldPrefix}${DealParticipantsField.MAIN_BUYER}`}
        textFieldProps={{ label: t('Main Buyer'), margin: 'dense', placeholder: t('[ Select Main Buyer ID ]') }}
        getOptionLabel={getBuyerOptionLabel}
        disableClearable
        options={mainBuyerOptions}
        onChange={onMainBuyerChange as (e: SyntheticEvent, v: string) => void}
        loading={isBuyersLoading}
        value={isBuyersLoading ? '' : (mainBuyer as string)}
        data-test="deal-main-seat-id"
      />
      {!isTTDPartnerAndGuaranteedDealType && (
        <RHFAutoCompleteVirtualize
          name={`${fieldPrefix}${DealParticipantsField.BUYER_IDS}`}
          textFieldProps={{
            label: t('Additional Buyers (Optional)'),
            margin: 'dense',
            placeholder: t('[ Select Additional Buyer IDs ]'),
          }}
          getOptionLabel={getBuyerOptionLabel}
          options={filteredBuyersOption}
          onChange={onMultipleBuyerIdsChange as (e: SyntheticEvent, v: string[]) => void}
          multiple
          disabled={!mainBuyer}
          loading={isBuyersLoading}
          data-test="deal-dsp-seat-ids"
          limitTags={99}
        />
      )}
    </>
  );
};
